import { Badge, Button } from '@mui/material';
import { memo, useCallback, useState } from 'react';
import { useQuery } from 'react-query';
import useAxiosPrivate from 'hooks/useAxiosPrivate';
import NotificationDrawer from './NotificationDrawer';

const NotificationMenu = () => {
  const axiosPrivate = useAxiosPrivate();
  const [isOpen, setIsOpen] = useState(false);

  // Ro'yxat sahifalab yuklanadi (backend 12 tadan beradi):
  // ochilganda 1-sahifa, pastga tushilganda keyingi sahifa qo'shiladi.
  const [items, setItems] = useState([]);
  const [page, setPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const [loading, setLoading] = useState(false);

  // MUHIM: bitta xato bo'lganda so'rovni butunlay o'chirib qo'ymaymiz
  // (aks holda qo'ng'iroqcha bosilmaguncha yangi bildirishnomalar kelmaydi).
  // Sanoq muntazam yangilanib turadi; ro'yxat FAQAT qo'ng'iroqcha bosilganda so'raladi.
  // O'qilgan deb belgilash — faqat bosilgan bildirishnoma (yoki "hammasi" tugmasi).
  const { data: count, refetch: refetchCount } = useQuery({
    queryKey: '/dictionary/notificationcount',
    queryFn: async function () {
      const response = await axiosPrivate.get('/dictionary/notificationcount');
      return response.data.data;
    },
    retry: false,
    refetchInterval: 20000,
    refetchOnWindowFocus: true,
  });

  const fetchPage = useCallback(
    async (p, replace = false) => {
      setLoading(true);
      try {
        const response = await axiosPrivate.get(
          `/dictionary/notifications?page=${p}`
        );
        const d = response?.data?.data;
        const list = d?.data || [];
        setItems((prev) => (replace ? list : [...prev, ...list]));
        setPage(d?.current_page || p);
        setLastPage(d?.last_page || p);
      } catch (e) {
        // jim — keyingi urinishda qayta yuklanadi
      } finally {
        setLoading(false);
      }
    },
    [axiosPrivate]
  );

  const handleClick = async () => {
    setIsOpen(true);
    await fetchPage(1, true);
  };

  // Bitta bildirishnoma bosildi — faqat shu o'qilgan bo'ladi
  const markRead = useCallback(
    async (notification) => {
      if (!notification || notification.isread) return;
      setItems((prev) =>
        prev.map((n) => (n.id === notification.id ? { ...n, isread: 1 } : n)),
      );
      try {
        await axiosPrivate.post(`/dictionary/notifications/${notification.id}/read`);
      } catch (e) {
        // jim — sanoq keyingi tekshiruvda to'g'rilanadi
      }
      refetchCount();
    },
    [axiosPrivate, refetchCount],
  );

  // "Hammasini o'qilgan deb belgilash"
  const markAllRead = useCallback(async () => {
    setItems((prev) => prev.map((n) => ({ ...n, isread: 1 })));
    try {
      await axiosPrivate.post('/dictionary/notifications/read-all');
    } catch (e) {
      // jim
    }
    refetchCount();
  }, [axiosPrivate, refetchCount]);

  // Pastga tushilganda keyingi sahifa
  const loadMore = () => {
    if (loading || page >= lastPage) return;
    fetchPage(page + 1);
  };

  return (
    <div className='notification-menu-wrapper ml-auto'>
      <Button
        variant='base'
        size='small'
        sx={{ padding: '6px 12px' }}
        rotate='true'
        onClick={handleClick}
      >
        <Badge badgeContent={count || 0} invisible={!count} color='error'>
          <i className='bi bi-bell' />
        </Badge>
      </Button>
      <NotificationDrawer
        open={isOpen}
        setOpen={setIsOpen}
        data={items}
        loading={loading}
        hasMore={page < lastPage}
        onLoadMore={loadMore}
        onRead={markRead}
        onReadAll={markAllRead}
      />
    </div>
  );
};

export default memo(NotificationMenu);
